<template lang="pug">
    button.button-control(:class='theClass' @click='click')
        span
            slot
        .button-control__spinner-container(v-if="loading")
            .button-control__spinner
</template>

<script>
export default {
    name: 'button-control',
    props: {
        mode: {
            type: String,
            validate: (v) => !v || ['apply', 'cancel'].includes(v),
            default: 'apply',
        },
        disabled: {
            type: Boolean,
        },
        loading: {
            type: Boolean,
        },
    },
    computed: {
        theClass() {
            return {
                [`button-control--mode-${this.mode}`]: true,
                'button-control--disabled': this.disabled,
                'button-control--loading': this.loading,
            }
        },
    },
    methods: {
        click() {
            if (!this.disabled && !this.loading) {
                this.$emit('click')
            }
        },
    },
}
</script>
